//#region src/components/hours-of-operation/days.ts
const days = [
	"sunday",
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday"
];

//#endregion
export { days };